import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useTranslation } from 'localization';
import './language-switcher.scss';
import { t } from 'i18next';

interface LanguageSwitcherProps {
    languages: string[];  // List of languages to display
    selectedLanguage: string;  // Currently selected language
    onLanguageChange: (language: string) => void;  // Callback to handle language change
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
    languages,
    selectedLanguage,
    onLanguageChange,
}) => {
    const { i18n } = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState(selectedLanguage || 'en-US');  // Set initial language

    useEffect(() => {
        if (selectedLanguage) {
            setCurrentLanguage(selectedLanguage);  // Set default language from props
            i18n.changeLanguage(selectedLanguage);  // Update i18n language
        }
    }, [selectedLanguage, i18n]);

    const handleLanguageChange = (lang: string) => {
        i18n.changeLanguage(lang);  // Change language in i18n
        setCurrentLanguage(lang);   // Update local state
        onLanguageChange(lang);     // Call the passed callback to notify parent component
    };

    return (
        <>
            <label className='lag-label mr-2'>{t('Preferred language.label')}</label>
            <Dropdown 
            value={currentLanguage} 
            options={languages.map((lang) => {
                let label;
                if (lang === 'en-US') {
                label = 'English (US)';
                } else if (lang === 'fr-CA') {
                label = 'Français (Canada)';
                } else {
                label = 'Français';
                }
                return { label, value: lang };
            })}
            onChange={(e) => handleLanguageChange(e.value)}
            className="language-switcher-dropdown"
            placeholder="Select a Language"
            />
        </>
    );
};

export default LanguageSwitcher;
